/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { GpsQualityOverridePb } from "../../../../gen/sensors/gps_quality_override";

export const protobufPackage = "skills";

export interface OverrideGpsQualityActionArgs {
  override: GpsQualityOverridePb | undefined;
}

export interface OverrideGpsQualityResultData {
}

export interface OverrideGpsQualityActionStateData {
}

function createBaseOverrideGpsQualityActionArgs(): OverrideGpsQualityActionArgs {
  return { override: undefined };
}

export const OverrideGpsQualityActionArgs = {
  encode(message: OverrideGpsQualityActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.override !== undefined) {
      GpsQualityOverridePb.encode(message.override, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OverrideGpsQualityActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOverrideGpsQualityActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.override = GpsQualityOverridePb.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OverrideGpsQualityActionArgs {
    return { override: isSet(object.override) ? GpsQualityOverridePb.fromJSON(object.override) : undefined };
  },

  toJSON(message: OverrideGpsQualityActionArgs): unknown {
    const obj: any = {};
    if (message.override !== undefined) {
      obj.override = GpsQualityOverridePb.toJSON(message.override);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OverrideGpsQualityActionArgs>, I>>(base?: I): OverrideGpsQualityActionArgs {
    return OverrideGpsQualityActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OverrideGpsQualityActionArgs>, I>>(object: I): OverrideGpsQualityActionArgs {
    const message = createBaseOverrideGpsQualityActionArgs();
    message.override = (object.override !== undefined && object.override !== null)
      ? GpsQualityOverridePb.fromPartial(object.override)
      : undefined;
    return message;
  },
};

function createBaseOverrideGpsQualityResultData(): OverrideGpsQualityResultData {
  return {};
}

export const OverrideGpsQualityResultData = {
  encode(_: OverrideGpsQualityResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OverrideGpsQualityResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOverrideGpsQualityResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): OverrideGpsQualityResultData {
    return {};
  },

  toJSON(_: OverrideGpsQualityResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<OverrideGpsQualityResultData>, I>>(base?: I): OverrideGpsQualityResultData {
    return OverrideGpsQualityResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OverrideGpsQualityResultData>, I>>(_: I): OverrideGpsQualityResultData {
    const message = createBaseOverrideGpsQualityResultData();
    return message;
  },
};

function createBaseOverrideGpsQualityActionStateData(): OverrideGpsQualityActionStateData {
  return {};
}

export const OverrideGpsQualityActionStateData = {
  encode(_: OverrideGpsQualityActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OverrideGpsQualityActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOverrideGpsQualityActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): OverrideGpsQualityActionStateData {
    return {};
  },

  toJSON(_: OverrideGpsQualityActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<OverrideGpsQualityActionStateData>, I>>(
    base?: I,
  ): OverrideGpsQualityActionStateData {
    return OverrideGpsQualityActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OverrideGpsQualityActionStateData>, I>>(
    _: I,
  ): OverrideGpsQualityActionStateData {
    const message = createBaseOverrideGpsQualityActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
